module.exports = __webpack_public_path__ + "media/images/country_flags/pg-6f6b135f65b6d55006e04bfeb8d8fd59.png";